module.exports = __webpack_public_path__ + "img/ic-maestro-no-color.5bd87c83.svg";